import { ofType, ActionsObservable } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import {format} from 'one-util-date';

import {
    SETPATIENTSELECTED,
    SET as PATIENTSET,
    RESET as PATIENTRESET,
    SETSELECTED_CERNER,
    SET_CERNER as PATIENTCERNER
} from 'one-state-subject/src/types';

import {
    TransformBillingDetailsCerner
} from './transform';

import {
    setActionCerner as setBillingActionCerner,
    selectActionCerner as selectBillingAction,
    Billing,
    resetAction,
    selectActionCerner
} from 'one-state-billing-details-cerner';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';
import { Disposition } from 'one-model-local';
import { InvokeFinesseProxy } from '../../subject/src/index';
import { setAction } from 'one-state-source-local';
import { setActionCerner } from 'one-state-patient-global-search';

export const enum Types {
    SETBILLING = 'set-billing/set-cerner',
    BILLINGDETAILS = 'one-state-billing-details/set-cerner',
    STORE_DISPOSITION_CODE = "store-disposition-code",
    SETSTATEMENTNUMBER = 'one-state-getstatementnumber/set',
}

const setBilling = (payload: any) => ({ type: Types.SETBILLING, payload });
const pushtoSetBillingDetailsCerner = (payload: any) => setBillingActionCerner(payload);
const pushSelectedBillingDataToState = (payload: any) => selectBillingAction(payload);
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });


export const fetchBillingDetailsFromCerner = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { server,
            log,
            agentId,
            teamName,
            alertnotification,
            settings:
            {
                servers,
                cernerendpoints: { getbillingdetails, apitoken },
                uisettings: {
                    dashboardapiconfig: {
                        getbillingdetails: getbillingdetailsApi
                    }
                },
                compatible: { consolidated_api_invocation, contact_center_type, finesse_proxy_service },
            }
        } = context;
        const { locations = [] } = servers;
        return action$.pipe(
            ofType(Types.SETSTATEMENTNUMBER),
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the patient request
                 */
                const dataresponse: any = action.payload;
                log.debug("one-epics/cerner-epics", "getbillingDetailsCerner request", dataresponse);
                const getBillingDetails = (payload: any) => {
                    let headers = new Headers();
                    headers.set('Authorization', 'Basic ' + apitoken?.token);
                    let response;
                    if (finesse_proxy_service) {
                        response = InvokeFinesseProxy(getbillingdetails + "?PatientID=" + payload?.id+"&StatementNumber"+ (payload.statementnumber ? payload.statementnumber : ""), "", apitoken, locations, log, 'GET', alertnotification);

                    } else {
                        response = server.get({
                            path: getbillingdetails + "?PatientID=" + payload?.id+"&StatementNumber="+payload.statementnumber,
                            headers: headers
                        }).then((responsefound: any) => responsefound)
                            .catch((responseresult: any) => {
                                log.error(
                                    "ccw-gadget,getbillingDetailsCerner-cerner",
                                    "fetch-getbillingDetails-Cerner", {
                                    responseresult
                                }
                                );
                                // SEND to ALERT snotificiton/NOCserver for errors
                                if (responseresult?.status === 0) {
                                    if (alertnotification?.isEnabled()) {
                                        var timestamp = new Date().toJSON();
                                        alertnotification.notify({
                                            "error_code": "930-31",
                                            "error_type": "SERVER_ERROR",
                                            "error_description": "Unable to reach active servers",
                                            "error_supertype": "SERVER_FAILS",
                                            "error_detail": "Unable to reach any of server for retring data ",
                                            "alert": "Yes",
                                            "timestamp": timestamp,
                                            "params": responseresult
                                        });
                                    }
                                }
                                let sourceerror: ErrorObject = {
                                    source: "Billing",
                                    type: "error",
                                    status: responseresult?.status,
                                    erroritems: responseresult?.errors,
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                return sourceerror;
                            })
                        log.debug("one-epics/cerner-epics", "getbillingDetailsCerner response", response);
                    }
                    return from(response);
                }
                if (!getbillingdetailsApi) return []
                return getBillingDetails(dataresponse).pipe(
                    flatMap((response: any) => {
                        const actions: any = [
                            setBilling(response)
                        ];

                        if (response && (response.status >= 400 || response.type == "error")) {
                            actions.push(addAction(response));
                            let disp: Disposition = { value: "1007" }
                            if (contact_center_type && contact_center_type === 'five9') {
                                let agentIdValue = sessionStorage.getItem("agentName");
                                let skillName = sessionStorage.getItem("skillName");
                                disp.meta00 = agentIdValue;
                                disp.meta01 = skillName;
                                disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                            } else {
                                disp.meta00 = agentId;
                                disp.meta01 = teamName;
                                disp.dial_list_uid = state$.value.choosecaller?.callId;
                            }
                            disp.meta02 = dataresponse?.id;
                            disp.meta03 = response.status;
                            disp.meta04 = response.erroritems?.[0]?.error_detail;
                            disp.meta05 = 'client';
                            actions.push(pushToDisposition(disp));
                        } else {
                            let disp: Disposition = { value: "190" }
                            if (contact_center_type && contact_center_type === 'five9') {
                                let agentIdValue = sessionStorage.getItem("agentName");
                                let skillName = sessionStorage.getItem("skillName");
                                disp.meta00 = agentIdValue;
                                disp.meta01 = skillName;
                                disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                            } else {
                                disp.meta00 = agentId;
                                disp.meta01 = teamName;
                                disp.dial_list_uid = state$.value.choosecaller?.callId;
                            }
                            disp.meta02 = dataresponse.id;
                            disp.meta03 = '200';
                            disp.meta04 = 'client';
                            actions.push(pushToDisposition(disp));
                        }

                        return actions;
                    })
                )
            })
        )
    }

);

/**
 * This Function is used to fetch billing details
 * @param context contains settings json etc ..
 */
export const pushBillingDetailsToStateCerner = (context: any) => (
    (action$: any, state$: any) => {
        const {
            log
        } = context;
        return action$.pipe(
            ofType(Types.SETBILLING),
            mergeMap((action: any) => {
                /**
                 * @param response contains the appointment response
                 */
                let response = action.payload;

                log.debug("one-epics/cerner-epics", "fetch Billing Details request", response);
                if (response) {
                    const performBillingTransformation = (datares: any) => {
                        let result = TransformBillingDetailsCerner(response, context);
                        log.debug("one-epics/cerner-epics", "fetch Billing Details response", result);
                        return from([result]);
                    }
                    return performBillingTransformation(response).
                        pipe(
                            map((transformresponse: any) => pushtoSetBillingDetailsCerner(transformresponse.billingdata)
                             )
                        )
                }
                else{
                    return from([]);
                }                
            })

        )
    }
);

/**
 * This function is used to push the default selected value
 * for billing module.
 * @param context has logger etc.
 */
export const pushSelectedBillingDataCerner = (context: any) => (
    (action$: any, state$: any) => {
        const {
            log
        } = context;
        return action$.pipe(
            ofType(Types.BILLINGDETAILS),
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the request to select default billing details
                 */
                let dataresponse = action.payload;

                const getRequest = (datares: any) => {
                    const billing: Billing[] = state$.value.billingdetailscerner?.values;
                    let selectedbilling: string = "";
                    if(billing?.length > 0){
                        selectedbilling = billing[0].AccountId;
                    }
                    log.debug("one-epics/cerner-epics", "pushSelectedBillingData response", selectedbilling);

                    return from([selectedbilling]);
                }

                return getRequest(dataresponse).pipe(
                    map(response => pushSelectedBillingDataToState(response))
                )
            })

        )
    }
);

/**
 * Listen for component clear and intiate state clear for Billing
 * @param context  contains logger which is used for logging
 */
export const clearBillingCerner = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, billing-cerner",
            "clear-billing-cerner", {
        });
        return action$.pipe(
            ofType( PATIENTRESET, SETPATIENTSELECTED,PATIENTCERNER,SETSELECTED_CERNER),
            map(action => resetAction())
        )

    }
);